import Arrow from '../../public/darkBlueArrow.svg';
import { AccordionSummary, Typography } from '@mui/material';
import { styled } from '@mui/system';
import styles from '../../styles/Praca.module.scss';

export const AccordionSummaryStyled = styled((props) => (
  <AccordionSummary
    {...props}
    expandIcon={
      props.isExpanded ? (
        ''
      ) : (
        <>
          <Typography className={styles.showMore}>Zobacz więcej</Typography>
          <Arrow />
        </>
      )
    }
  />
))(() => ({
  '&': {
    flexWrap: 'nowrap',
  },
  ' .MuiAccordionSummary-expandIconWrapper': {
    alignItems: 'center',
    width: '200px',
    '& svg': {
      marginLeft: '8px',
      transform: 'rotate(90deg)',
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'none',
    display: 'none',
  },

  '@media (max-width:1365px)': {
    '&': {
      flexWrap: 'wrap',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginLeft: 'auto',
    },
  },
}));
